/**
 * Barra de navegación.
 *
 * Hoy el POS es una sola pantalla, así que estos íconos son marcadores de los
 * módulos que vienen (cocina, domicilios, informes). Se dejan visibles y
 * deshabilitados en vez de ocultos: el dueño ve desde el primer día hacia
 * dónde va el sistema, y no hay que rediseñar la barra cuando lleguen.
 */

const SECCIONES = [
  { id: 'mesas', icono: '▦', titulo: 'Mesas', activo: true },
  { id: 'cocina', icono: '✷', titulo: 'Cocina (próximamente)', activo: false },
  { id: 'domicilios', icono: '◷', titulo: 'Domicilios (próximamente)', activo: false },
  { id: 'informes', icono: '◪', titulo: 'Informes (próximamente)', activo: false },
];

export function Rail({
  onCerrarSesion,
  onCarta,
}: {
  onCerrarSesion: () => void;
  onCarta: () => void;
}) {
  return (
    <nav className="rail" aria-label="Secciones">
      <div className="brand">CN</div>
      {SECCIONES.map((s) => (
        <button
          key={s.id}
          title={s.titulo}
          aria-current={s.activo ? 'true' : undefined}
          disabled={!s.activo}
          style={s.activo ? undefined : { opacity: 0.45, cursor: 'not-allowed' }}
        >
          {s.icono}
        </button>
      ))}
      <div className="spacer" />
      <button title="Carta y precios" onClick={onCarta}>
        ⚙
      </button>
      <button title="Cerrar sesión" onClick={onCerrarSesion}>
        ⏻
      </button>
    </nav>
  );
}